import { NotificationsService } from 'angular2-notifications';
import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import Clipboard from 'clipboard';

@Directive({
  selector: '[clipboard]'
})
export class ClipboardDirective {
  clipboard: Clipboard;

  @Input('clipboard')
  elt:ElementRef;

  @Output()
  clipboardSuccess:EventEmitter<any> = new EventEmitter();

  @Output()
  clipboardError:EventEmitter<any> = new EventEmitter();

  constructor(
    private eltRef: ElementRef,
    private notificationService: NotificationsService
  ) {}

  ngOnInit() {
    this.clipboard = new Clipboard(this.eltRef.nativeElement, {
      target: () => {
        return this.elt;
      }
    });

    this.clipboard.on('success', (e) => {
      this.notificationService.success('Sukces!', 'Pomyślnie skopiowano do schowka');
      this.clipboardSuccess.emit();
    });

    this.clipboard.on('error', (e) => {
      this.notificationService.success('Sukces!', 'Błąd przy kopiowaniu do schowka');
      this.clipboardError.emit();
    });
  }

  ngOnDestroy() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/clipboard.directive.ts